import Unlocked from 'components/bootcamp-analytic/Unlocked';
// import { useGetCapstoneQuery } from 'components/capstone/capstoneSlice';
import Loading from 'components/global/layout/Loading';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from 'config/API_LINKS';

const IntermediateLevel = () => {
  // const [locked, setLocked] = useState(true);

  const [capstoneData, setCapstoneData] = useState<any>([]);

  useEffect(() => {
    const capstoneIds = [
      '64d06bd3526d180014ad5ff0',
      '64d90ecde0ae3200145c3a9d',
    ];
    const fetchData = async () => {
      const data = await Promise.all(
        capstoneIds.map(async (capstoneId: any) => {
          const capstone = await axios(API_URL + '/capstone', {
            params: { capstoneId },
          });
          return capstone?.data?.data[0];
        })
      );
      setCapstoneData(data);
    };

    fetchData();
  }, []);

  return (
    <div>
      {capstoneData.length > 0 ? (
        <Unlocked capstoneData={capstoneData} />
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default IntermediateLevel;
